export var COMPOSE_ONLY_ATTACHMENT_CONTENT_START = 'owa-attachment-remove-on-send-start';
export var COMPOSE_ONLY_ATTACHMENT_CONTENT_END = 'owa-attachment-remove-on-send-end';
var contentToRemove = new RegExp("<!--" + COMPOSE_ONLY_ATTACHMENT_CONTENT_START + "-->.*?<!--" + COMPOSE_ONLY_ATTACHMENT_CONTENT_END + "-->", 'gim');
export default function removeComposeOnlyContent(html) {
    if (html) {
        return html.replace(contentToRemove, '');
    }
    else {
        return html;
    }
}
//# sourceMappingURL=removeComposeOnlyContent.js.map